import auth from './auth'
import user from './user'
import toast from './toast'

export default {
  auth,
  user,
  toast
}
